import type { ProductItem } from '@/js/types/catalog.ts';
import type { FilterData } from '@/js/types/filter.ts';
import type { AxiosRequestConfig } from 'axios';
import { makeLocalizedStoreApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function getProductsByQuery(query: string) {
  return makeRequest<ProductItem[]>({
    method: 'POST',
    url: makeLocalizedStoreApiRoute('catalog/products/search'),
    data: {
      query,
    },
  });
}

export async function filter(categoryId: number, filters: Record<string, any>, options?: AxiosRequestConfig) {
  return makeRequest<FilterData>({
    ...options,
    method: 'POST',
    url: makeLocalizedStoreApiRoute(`catalog/get-filters`),
    data: {
      category_id: categoryId,
      filters,
    },
  });
}
